<template>
  <!-- Grid Two  -->
  <section class="grid_two big_container new-two-grid-sec-full-bleed" :style="sectionStyles">
    <div class="mobile_stories">
      <button class="story_cta" aria-label="Show Stories" type="button" @click="toggleStories">
        <img
          src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/mobile-stories.svg?v=1655358553"
          alt="Mobile Stories Icon"
          loading="lazy"
          decoding="async"
          width="48"
          height="48"
          fetchpriority="low"
        />
      </button>
    </div>
    <div class="mobile_stories_wrapper" :class="{ active: !show, iphone: !iphoneDevice }">
      <swiper
        :scrollbar="{ hide: false }"
        :modules="modules"
        :slides-per-view="'auto'"
        :space-between="10"
        :mousewheel="{
          invert: false,
          releaseOnEdges: true,
        }"
        navigation
      >
        <swiper-slide v-for="(value, key) in shopifyData.storyData" :key="key">
          <div class="card_preview_img">
            <img
              v-lazy="value.previewimage.src"
              :alt="value.previewimage.alt || 'Preview Image'"
              :width="value.previewimage.width || 600"
              :height="value.previewimage.height || 600"
              loading="lazy"
              decoding="async"
              fetchpriority="low"
            />
          </div>
          <div class="slider_product_btn">
            <a :href="value.storyBtnLink" class="slider_tmb_btn" aria-label="Story Button">
              <img
                src="//cdn.shopify.com/s/files/1/0577/1178/8125/t/5/assets/slider-arrow.svg?v=7926845654508591761"
                alt="Slider Arrow Icon"
                width="24"
                height="24"
                decoding="async"
                fetchpriority="low"
              />
            </a>
            <span
              class="color-white subtitle"
              :style="{ color: value.bottomTextColor }"
              v-html="value.storyBtn"
            />
          </div>
          <div
            class="close_icon"
            aria-label="Close Stories"
            @click="((show = !show), addActiveBody())"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/x-storie.svg?v=1655114346"
              alt="Close Icon"
              class="popup_close"
              decoding="async"
              fetchpriority="low"
            />
          </div>
          <div
            v-if="value.storyHeading || value.storyBrief"
            class="sec_text"
            :style="{ top: value.storyText + '%' }"
          >
            <h4 class="card_heading_b" v-html="value.storyHeading" />
            <p class="body_text" v-html="value.storyBrief" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="grid_two_inner" :style="gridGap">
      <div v-for="(value, key) in shopifyData.box" :key="key" class="grid_item">
        <Transition name="nested" appear>
          <div class="grid_img-wrap line-h-0 d-block outer" aria-label="Grid Image Wrap">
            <h3 class="grid_item_title" :style="{ color: value.titleColor }">
              {{ value.title }}
            </h3>
            <component :is="value.link ? 'a' : 'div'" :href="value.link">
              <ResponsiveImage
                :img="value.imgUrl"
                wrapper-class="inner"
                img-class="image new-grid-image"
                sizes="100vw"
              />
            </component>
            <a :href="value.link" class="grid_item_cta modify_cta cta_btn cta_btn-white">
              {{ value.linkText }}
            </a>
          </div>
        </Transition>
        <!-- <div
          v-if="value.title"
          class="grid_info"
          :style="{ paddingLeft: value.deskPaddingLeftText + 'px' }"
        >
          <h3 class="card_heading grid_heading d-block" v-html="value.title" />
          <a
            :href="value.link"
            class="link body_text d-block"
            aria-label="Grid Link"
            v-html="value.linkText"
          />
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';
import ResponsiveImage from '../snippets/ResponsiveImage.vue';

export default {
  components: {
    Swiper,
    SwiperSlide,
    ResponsiveImage,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Scrollbar],
    };
  },
  data() {
    window.addEventListener('scroll', () => {
      const heroSec = document?.querySelectorAll('section');
      const storyCta = document?.querySelector('.mobile_stories');
      const heroHeight = heroSec[0]?.getBoundingClientRect().height;
      if (window.scrollY > heroHeight) {
        storyCta.setAttribute('style', 'opacity:1;visibility:visible;');
      } else {
        storyCta.setAttribute('style', 'opacity:0;visibility:hidden;');
      }
    });
    return {
      show: true,
      iphoneDevice: true,
    };
  },
  computed: {
    sectionStyles() {
      return {
        paddingLeft:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingLeft || '0') + 'px'
            : (this.shopifyData.mobPaddingLeft || '0') + 'px',
        paddingRight:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingRight || '0') + 'px'
            : (this.shopifyData.mobPaddingRight || '0') + 'px',
        paddingTop:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingTop || '0') + 'px'
            : (this.shopifyData.mobPaddingTop || '0') + 'px',
        paddingBottom:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingBottom || '0') + 'px'
            : (this.shopifyData.mobPaddingBottom || '0') + 'px',
      };
    },

    gridGap() {
      return {
        rowGap:
          window.innerWidth > 768
            ? (this.shopifyData.desktopRowGap || '0') + 'px'
            : (this.shopifyData.mobileRowGap || '0') + 'px',
        columnGap:
          window.innerWidth > 768
            ? (this.shopifyData.desktopColGap || '0') + 'px'
            : (this.shopifyData.mobileColGap || '0') + 'px',
      };
    },
  },
  methods: {
    toggleStories() {
      this.show = !this.show;
      this.addActiveBody();
    },
    addActiveBody() {
      document.querySelector('body').classList.toggle('show');
      const agentPlatform = navigator.platform;
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (agentPlatform == 'iPhone' || isSafari) {
        this.iphoneDevice = !this.iphoneDevice;
      }
    },
  },
};
</script>

<style scoped>
/* rules that target nested elements */
.nested-enter-active .inner,
.nested-leave-active .inner {
  transition: all 0.5s ease-in-out;
}

.nested-enter-from .inner,
.nested-leave-to .inner {
  transform: translateY(-30px);
  opacity: 0;
}
/* Two Grid */
.grid_two {
  padding: 0 15px;
}

.grid_item {
  position: relative;
}

.grid_item_title {
  position: absolute;
  left: 50%;
  top: 95px;
  transform: translate(-50%);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #fff;
}

.grid_item_cta {
  position: absolute;
  left: 50%;
  bottom: 95px;
  transform: translate(-50%);
}

.grid_two_inner {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 25px 5px;
}

.grid_two_inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px 5px;
}

::v-deep(.image.new-grid-image) {
  width: 100%;
  max-width: 100%;
}
.grid_two_inner .grid_img-wrap {
  display: block;
  overflow: hidden;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  min-height: 200px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.mobile_stories,
.mobile_stories_wrapper {
  display: none;
}

/* @media only screen and (max-width: 991px) {
  .grid_two {
    padding: 0;
  }
} */
.image.new-grid-image {
  width: 100%;
}

.new-grid-image {
  height: auto;
  object-fit: cover;
  object-position: center;
  aspect-ratio: 412 / 499;
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .grid_two_inner {
    grid-template-columns: 100%;
  }
  .grid_item_title {
    top: 35px;
    font-size: 14px;
    line-height: 1.2;
  }

  .grid_item_cta {
    bottom: 35px;
  }
}

@media only screen and (max-width: 575px) {
  .mobile_stories {
    display: block;
    margin-bottom: -30px;
    position: fixed;
    z-index: 3;
    top: 80px;
    left: 22px;
    border-radius: 50%;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
  }
  .grid_img {
    aspect-ratio: 412 / 499;
  }

  /* mobile stories css start */
  .mobile_stories_wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    visibility: hidden;
    opacity: 0;
    transition: 0.3s;
    height: 100%;
    min-height: 100vh;
    background-color: #fff;
    display: block;
    overflow-y: scroll;
    overscroll-behavior: touch;
  }

  .mobile_stories_wrapper.active {
    visibility: visible;
    opacity: 1;
  }

  .slider_product_btn {
    display: grid;
    margin-right: 0;
    gap: 13px;
    position: absolute;
    bottom: 17px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }

  .iphone .slider_product_btn {
    bottom: 85px;
  }

  .subtitle {
    margin: 0;
  }

  .slider_product_btn img {
    transform: rotate(90deg);
  }

  .close_icon {
    position: absolute;
    top: 15px;
    left: 0;
  }

  .mobile_stories_wrapper .card_preview_img img {
    height: 100vh;
    object-fit: cover;
    width: 100% !important;
    object-position: center;
  }

  .mobile_stories_wrapper .card_heading_b {
    margin: 0 0 14px 0;
    font-size: 12px;
    line-height: 10.49px;
    color: #fff;
  }

  .mobile_stories_wrapper .body_text {
    font-size: 12px;
    line-height: 12.95px;
    color: #fff;
  }

  .sec_text {
    position: absolute;
    top: 30%;
    background: #000;
    padding: 23px 25px;
    max-width: 309px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }
}

@media only screen and (max-width: 412px) {
  .grid_img {
    aspect-ratio: 412 / 499;
    max-width: 412px;
    width: 100%;
  }
}
</style>
